import React from 'react';
const {PropTypes} = React;

const Icon = props => {
    const styles = {
        svg: {
        },
        path: {

        },
    };

    return (
        <svg
            version="1.1"
            xlinkHref="http://www.w3.org/1999/xlink"
            xmlns="http://www.w3.org/2000/svg"
            width={`${props.width}px`}
            height={`${props.height}px`}
            viewBox={props.icon.viewBox}
            style={styles.svg}
        >
            <path
                style={styles.path}
                d={props.icon.d}
                fill={props.color}
                fillRule={props.rules}
                clipRule={props.rules}
            ></path>
        </svg>
    );
};

Icon.propTypes = {
    icon: PropTypes.object.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
    color: PropTypes.string,
    rules: PropTypes.string,
};

Icon.defaultProps = {
    width: 16,
    height: 16,
    rules: 'evenodd',
};

export default Icon;


// WEBPACK FOOTER //
// ./src/_app/icons/icon.jsx